import { render, staticRenderFns } from "./AppNotificationEventListener.vue?vue&type=template&id=592c0da9"
import script from "./AppNotificationEventListener.vue?vue&type=script&lang=js"
export * from "./AppNotificationEventListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports